﻿export class AmbiguousDataVersion {
}